const prescriptionUpload = {
  mainTitle: 'Lösen Sie Ihr (E-)Rezept ein',
  subtitle: ' Lösen Sie Ihre Rezepte einfach online ein und erhalten Sie die Produkte innerhalb kürzester Zeit in Ihrer Apotheke vor Ort oder per Botendienst.',
  itsThatEasy: 'So einfach geht\'s',
  yourEPrescription: 'Ihre (E-)Rezepte',
  continueShopping: 'Weiter einkaufen',
  goToCart: 'Zum Warenkorb',
  tooltipContent: {
    whereToFindQuestion: 'Wo finde ich den scanbaren Code?',
    whereToFindAnswer: `Wenn Sie das gesamte Rezept einlösen wollen, scannen Sie einfach den QR-Code in der oberen rechten Ecke. Darin sind alle notwendigen Informationen enthalten. Wenn Sie nur einzelne Positionen einlösen wollen, können Sie auch nur die Einzel-Codes scannen.
    Bitte beachten Sie: Sie können nur 4 Codes je Vorbestellung einlösen. Bei mehr als 4 Codes platzieren Sie einfach eine weitere Vorbestellung`,
    whichCodesQuestion: 'Welche Codes können gescannt werden?',
    whichCodesAnswer: 'Sie erhalten E-Rezepte genauso wie klassische Rezepte nur von Ihrem Arzt oder Ihrer Ärztin.',
    codeNotRecognizedQuestion: 'Was tun, wenn der Code nicht erkannt wird?',
    codeNotRecognizedAnswer: 'Sollte der Code nicht sofort erkannt werden, bewegen oder kippen Sie die Kamera leicht über dem Code. Sie können auch den Abstand verändern. Achten Sie in jedem Fall auf gute Beleuchtung!',
    otherProblems: 'Andere Probleme beim Scannen?',
    reportProblem: 'Melden Sie ein Problem',
  },
  scanner: {
    scanningTips: 'Tipps zum Scannen',
    pleaseScan: 'Bitte scannen Sie den QR-Code in der oberen rechten Ecke Ihres E-Rezeptes.',
    enableCamera: 'Um Ihr E-Rezept zu scannen, müssen Sie Ihre Kamera aktivieren. Alternativ können Sie die Funktion zum Hochladen nutzen. Wie Sie Ihre Kamera aktivieren, erfahren sie',
    here: 'hier',
    couldNotIdentify: 'Wir konnten leider keine Medikation erkennen. Bitte versuchen Sie es erneut.',
    scanningProblem: 'Probleme beim Scannen?',
    codeNotRecognized: 'Falls der Code nicht erkannt wird:',
    uploadRecipe: 'Rezept hochladen',
    holdDeviceVertically: 'Bitte halten Sie das Gerät senkrecht.',
    scannedSuccessfully: 'Barcode erfolgreich gescannt',
    verticalDevice: 'Vertikales Gerät',
  },
  remove: {
    areYouSure: 'Sind Sie sicher, dass Sie dieses (E-)Rezept entfernen möchten?',
  },
  alerts: {
    removeSuccess: 'Ihr Rezept wurde erfolgreich gelöscht!',
    uploadErrorFileAccess: 'Zugriff verweigert. Bitte lassen Sie den Zugriff auf Ihre Dateien zu.',
    prescriptionAlreadyUploaded: 'Dieser Code wurde bereits verwendet. Das Rezept befindet sich in Ihrem Warenkorb.',
    uploadErrorFileSize: 'Ihre Datei konnte nicht hochgeladen, da sie die zulässige Größe von 8 MB übersteigt.',
    uploadErrorFileType: 'Das gewählte Dateiformat, “{extension}“ ist leider ungültig. Bitte wählen Sie für den Upload Ihres Rezepts eines der folgenden Dateiformate aus: .jpg, .jpeg, .png, .pdf',
  },
  hint: {
    availability: 'Verfügbarkeit',
    availabilityHint: 'Bestellungen werden innerhalb weniger Stunden vorbereitet und sind in der Regel am selben Tag oder spätestens am Folgetag verfügbar.',
  },
  iconWrapper: {
    step1: 'Schritt 1',
    step2: 'Schritt 2',
    step3: 'Schritt 3',
    step4: 'Schritt 4',
    titleFindPharmacy: 'Apotheke auswählen',
    titleUploadPrescription: 'Rezept hochladen',
    titleCompleteOrder: 'Bestellung abschließen',
    titleOrderReceived: 'Bestellung erhalten',
    textCompleteOrder: {
      0: 'Fügen Sie weitere Rezepte oder Produkte hinzu.',
      1: 'Rezeptpflichtige Medikamente müssen Sie nicht extra hinzufügen.',
    },
    textOrderReceived: {
      0: 'Bestellung in der Apotheke abholen oder liefern lassen.',
      1: 'Das Originalrezept muss bei der Übergabe vorgelegt werden.',
    },
    // old
    uploadPrescription: 'Sie laden Ihr Rezept oder E-Rezept hoch.',
    addRecipes: 'Fügen Sie weitere Rezepte hinzu oder schließen Sie die Bestellung ab. Sie müssen dafür die Produkte nicht noch zusätzlich hinzufügen.',
    handOverOriginal: 'Bei Lieferung oder Abholung übergeben Sie das Originalrezept.',
    stepIcon: 'Schrittsymbol',
  },
  note: {
    notice: 'Hinweis:',
    noticeHint: 'Wir führen Ihre Bestellung über das hochgeladene Rezept aus. Das verschriebene Medikament muss von Ihnen nicht noch einmal extra in den Warenkorb gelegt werden. Achten Sie beim Papier-Rezept darauf, dass das Rezept gut lesbar ist.',
  },
  item: {
    prescription: 'Rezept',
    ePrescription: 'E-Rezept',
    uploadedOn: 'Hochgeladen am',
    scannedOn: 'Gescannt am',
    with: 'mit',
    medications: 'Medikamenten',
    noteToPharmacy: 'Hinweis an Apotheke',
    yourComment: 'Ihr Kommentar ...',
  },
  redeem: {
    maxFour: 'Sie können maximal vier Rezepte in den Warenkorb legen. Für mehr Rezepte geben Sie bitte eine weitere Bestellung auf.',
    whichPrescription: 'Welches Rezept möchten Sie einlösen?',
    submitMore: 'Weiteres Rezept einlösen',
    uploadHere: 'Hier das gewünschte Rezept hochladen',
  },
  redeemItem: {
    ePrescription: 'E-Rezept',
    paperPrescription: 'Papier-Rezept',
    scan: 'Scannen',
    upload: 'Hochladen',
  },
  choosePharmacy: {
    which: 'In welcher lokalen Apotheke möchten Sie Ihre Rezepte einlösen?',
    select: 'Apotheke auswählen',
  },
  advantages: {
    title: 'Warum sollten Sie Rezepte über IhreApotheken.de einlösen?',
    0: {
      title: 'Schnelle Verfügbarkeit',
      text: 'Sobald Sie Ihr Rezept eingelöst haben, kann die Apotheke Ihre Bestellung bearbeiten oder Ihr Medikament bestellen, damit es schnellstmöglich bei Ihnen ist. In der Regel ist Ihre Bestellung innerhalb von wenigen Stunden abholbereit oder kann Ihnen per Lieferdienst nach Hause gebracht werden.',
    },
    1: {
      title: 'Einfach und sicher',
      text: 'Der Schutz Ihrer Daten ist unser Versprechen. (E-)Rezepte werden ausschließlich an die von Ihnen ausgewählte Apotheke übermittelt. IhreApotheken.de hat zu keinen Zeitpunkt Zugriff auf den Inhalt Ihres Rezepts.',
    },
    2: {
      title: 'Lokale Apotheke unterstützen',
      text: 'IhreApotheken.de ist der verlängerte digitale Arm der Apotheken vor Ort. Durch die Online-Einlösung ihres Rezeptes über IhreApotheken.de unterstützen Sie die systemrelevanten Apotheken vor Ort.',
    },
  },
  about: {
    whatIs: 'Was ist IhreApotheken.de?',
    whatDoesItDo: {
      0: 'Mit IhreApotheken.de können Sie einfach und sicher online Medikamente bestellen und Rezepte bei Ihrer Apotheke vor Ort einlösen.',
      1: 'Der Service ist für Sie kostenlos und Sie unterstützen damit die Apotheke vor Ort.',
    },
  },
  app: {
    nowAnApp: 'Jetzt auch als App!',
    usingApp: 'Lösen Sie Ihre (E-)Rezepte beim nächsten Mal noch schneller ein, mit der IhreApotheken.de-App.',
  },
  recipe: 'Rezept',
  qrCode: 'QR code',
}

export default prescriptionUpload
